<template>
  <div>
    <loading
      loader="dots"
      :height="170"
      :width="170"
      color="#3282b8"
      background-color="#505273"
      transition="fade"
      :active="isLoading"
      :is-full-page="true"
    ></loading>
    <div class="row">
      <div class="col-lg-2">
        <base-input label="Select Year">
          <el-select
            class="select-info"
            size="large"
            placeholder="Choose..."
            @change="swapYear()"
            v-model="selects.yearSelect"
          >
            <el-option
              v-for="years in selects.yearList"
              :value="years"
              :label="years"
              :key="years"
            ></el-option>
          </el-select>
        </base-input>
      </div>
      <div class="col-lg-10 text-right">
        <h1>
          The Year
          {{ selects.yearSelect }}
        </h1>
      </div>
      <div class="col-md-3 d-flex">
        <card class="card-chart card-chart-pie">
          <template slot="header">
            <h3 class="card-title">
              <b>Type of Accidents</b>
            </h3>
          </template>

          <div class="chart-area">
            <pie-chart
              :chart-data="pieChart1.chartData"
              :extra-options="pieChart1.extraOptions"
              height="160%"
            ></pie-chart>
          </div>
        </card>
      </div>
      <!-- Bar Chart -->
      <div class="col-lg-9">
        <card class="chart">
          <template slot="header">
            <h4 class="card-title">
              <i class="tim-icons icon-chart-bar-32 text-info"></i>&nbsp;
              <b>No of Accidents by Month</b>
            </h4>
          </template>
          <div class="chart-area">
            <bar-chart
              :chart-data="barChart1.chartData"
              :extra-options="barChart1.extraOptions"
              :gradient-colors="barChart1.gradientColors"
              :gradient-stops="barChart1.gradientStops"
              :height="200"
            ></bar-chart>
          </div>
        </card>
      </div>

      <div class="col-md-3 d-flex">
        <card class="card-chart card-chart-pie">
          <template slot="header">
            <h3 class="card-title">
              <b>Cause of Accident</b>
            </h3>
          </template>

          <div class="chart-area">
            <pie-chart
              :chart-data="pieChart2.chartData"
              :extra-options="pieChart2.extraOptions"
              height="160%"
            ></pie-chart>
          </div>
        </card>
      </div>
      <div class="col-lg-9">
        <card class="chart">
          <template slot="header">
            <h4 class="card-title">
              <i class="tim-icons icon-chart-bar-32 text-info"></i>&nbsp;
              <b>No of Accidents by Class</b>
            </h4>
          </template>
          <div class="chart-area">
            <bar-chart
              :chart-data="barChart2.chartData"
              :extra-options="barChart2.extraOptions"
              :gradient-colors="barChart2.gradientColors"
              :gradient-stops="barChart2.gradientStops"
              :height="200"
            ></bar-chart>
          </div>
        </card>
      </div>
      <div class="col-lg-12">
        <div class="row">
          <div class="col-md-3">
            <card card-body-classes="table-full-width">
              <!-- <h4 slot="header" class="card-title"></h4> -->
              <el-table
                :data="tableData"
                height="250"
                :header-cell-style="{
                  background: 'transparent',
                  border: 'none',
                  borderBottom: '0.5px solid #3d3f51',
                }"
                :cell-style="{
                  border: 'none',
                  borderBottom: '0.5px solid #3d3f51',
                }"
              >
                <el-table-column
                  min-width="150"
                  sortable
                  align="center"
                  label="Incident Location"
                  property="location"
                ></el-table-column>
              </el-table>
            </card>
          </div>
          <!-- Bar Chart -->
          <div class="col-md-5">
            <card class="chart">
              <template slot="header">
                <h4 class="card-title">
                  <i class="tim-icons icon-chart-bar-32 text-info"></i>&nbsp;
                  <b>No of MC &amp; LTI by Month</b>
                </h4>
              </template>
              <div class="chart-area">
                <bar-chart
                  :chart-data="barChart3.chartData"
                  :extra-options="barChart3.extraOptions"
                  :gradient-colors="barChart3.gradientColors"
                  :gradient-stops="barChart3.gradientStops"
                  :height="200"
                ></bar-chart>
              </div>
            </card>
          </div>
          <!-- Bar Chart -->
          <div class="col-md-4">
            <card class="chart">
              <template slot="header">
                <h4 class="card-title">
                  <i class="tim-icons icon-chart-bar-32 text-info"></i>&nbsp;
                  <b>No of Lost in company property by Month</b>
                </h4>
              </template>
              <div class="chart-area">
                <bar-chart
                  :chart-data="barChart4.chartData"
                  :extra-options="barChart4.extraOptions"
                  :gradient-colors="barChart4.gradientColors"
                  :gradient-stops="barChart4.gradientStops"
                  :height="200"
                ></bar-chart>
              </div>
            </card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, DatePicker, Select, Option } from "element-ui";

import BarChart from "@/components/Charts/BarChart";
import PieChart from "src/components/Charts/PieChart";
import config from "@/config";
import * as chartConfigs from "@/components/Charts/config";
import moment from "moment";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    PieChart,
    BarChart,
    Loading,
  },
  data() {
    return {
      isLoading: false,
      value1: "2020",
      selects: {
        yearlist: [],
        yearSelect: "",
      },
      // Bar Chart
      barChart1: {
        chartData: {
          labels: [
            "JAN",
            "FEB",
            "MAR",
            "APR",
            "MAY",
            "JUN",
            "JUL",
            "AUG",
            "SEP",
            "OCT",
            "NOV",
            "DEC",
          ],
          datasets: [
            {
              label: "Accidents",
              fill: true,
              backgroundColor: "rgba(204, 218, 70, 1)",
              borderColor: "rgba(204, 218, 70, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [],
            },
          ],
        },
        extraOptions: chartConfigs.barChartOptionsGradient,
        gradientColors: [
          "rgba(204, 218, 70, 0.8)",
          "rgba(246, 206, 71, 0.2)",
          "rgba(246, 206, 71, 0.0)",
        ],
        gradientStops: [1, 0],
      },
      barChart2: {
        chartData: {
          labels: [
            "JAN",
            "FEB",
            "MAR",
            "APR",
            "MAY",
            "JUN",
            "JUL",
            "AUG",
            "SEP",
            "OCT",
            "NOV",
            "DEC",
          ],
          datasets: [
            {
              label: "Class 1 (Fatality)",
              fill: true,
              borderColor: "#ffd369",
              backgroundColor: "#ffd369",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [],
            },
            {
              label: "Class 1 (Major)",
              fill: true,
              borderColor: "#e26241",
              backgroundColor: "#e26241",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [],
            },
            {
              label: "Class 2 (Minor)",
              fill: true,
              borderColor: "#940a37",
              backgroundColor: "#940a37",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [],
            },
            {
              label: "Class 3 (First Aid Near Miss)",
              fill: true,
              borderColor: "#5b0909",
              backgroundColor: "#5b0909",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [],
            },
          ],
        },
        extraOptions: chartConfigs.barChartOptionsGradient,
      },
      // Bar Chart
      barChart3: {
        chartData: {
          labels: [
            "JAN",
            "FEB",
            "MAR",
            "APR",
            "MAY",
            "JUN",
            "JUL",
            "AUG",
            "SEP",
            "OCT",
            "NOV",
            "DEC",
          ],
          datasets: [
            {
              label: "MC",
              fill: true,
              backgroundColor: "#bbe1fa",
              borderColor: "#bbe1fa",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [],
            },
            {
              label: "LTI",
              fill: true,
              backgroundColor: "#0f4c75",
              borderColor: "#0f4c75",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [],
            },
          ],
        },
        extraOptions: chartConfigs.barChartOptionsGradient,
        // gradientColors: [
        //   "rgba(246, 206, 71, 0.8)",
        //   "rgba(246, 206, 71, 0.2)",
        //   "rgba(246, 206, 71, 0.0)"
        // ],
        gradientStops: [1, 0],
      },
      // Bar Chart
      barChart4: {
        chartData: {
          labels: [
            "JAN",
            "FEB",
            "MAR",
            "APR",
            "MAY",
            "JUN",
            "JUL",
            "AUG",
            "SEP",
            "OCT",
            "NOV",
            "DEC",
          ],
          datasets: [
            {
              label: "Property in RM",
              fill: true,
              backgroundColor: "#3282b8",
              borderColor: "#3282b8",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: [],
            },
          ],
        },
        extraOptions: chartConfigs.barChartOptionsGradient,
        gradientColors: [
          "rgba(246, 206, 71, 0.8)",
          "rgba(246, 206, 71, 0.2)",
          "rgba(246, 206, 71, 0.0)",
        ],
        gradientStops: [1, 0],
      },
      // Pie Chart
      pieChart1: {
        chartData: {
          labels: [
            "Traffic",
            "Collection Activity",
            "Cleaning Activity",
            "Others",
          ],
          datasets: [
            {
              pointRadius: 0,
              pointHoverRadius: 0,
              backgroundColor: ["#004445", "#2c7873", "#6fb98f", "#ffd800"],
              borderWidth: 0,
              data: [],
            },
          ],
        },
        extraOptions: chartConfigs.pieChartOptions,
      },
      // Pie Chart
      pieChart2: {
        chartData: {
          labels: [
            "Unsafe Act",
            "Unsage Condition",
            "Out of Control",
            "Others",
          ],
          datasets: [
            {
              pointRadius: 0,
              pointHoverRadius: 0,
              backgroundColor: ["#10316b", "#000000", "#e25822", "#ececeb"],
              borderWidth: 0,
              data: [],
            },
          ],
        },
        extraOptions: chartConfigs.pieChartOptions,
      },
      tableData: [
        {
          location: "Kuala Lumpur",
        },
        {
          location: "Penang",
        },
        {
          location: "Melaka",
        },
      ],
    };
  },
  beforeDestroy() {
    console.log("SOCKS_CLOSED");
    this.socket.close();
  },
  created() {
    this.getYearList();
  },
  methods: {
    getYearList() {
      this.isLoading = true;
      this.$http.get(":9994/api/v1/overview/year").then((res) => {
        console.log(res);
        this.selects.yearList = res.message.map((a) => a.yearlist);
        // console.log(this.selects.yearSelect)
        this.selects.yearSelect = this.selects.yearList[0];
        console.log(this.selects.yearList);
        this.getSocketData();
        this.isLoading = false;
      });
    },
    swapYear() {
      // let year = moment(this.value1).format("YYYY");
      // this.value1 = year;
      console.log("REWRITE: ", this.selects.yearSelect);
      this.socket.close();
      this.getSocketData();
    },
    getSocketData() {
      console.log("CALLED");
      this.socket = new WebSocket(
        process.env.VUE_APP_WS_URL + ":9994/api/v1/overview/ADMIN_VIEW/ws"
      );

      this.socket.onopen = () => {
        this.status = "connected";
        console.log(this.status);
        this.socket.send(this.selects.yearSelect);
      };

      this.socket.onmessage = ({ data }) => {
        // console.log("sampai: ", data);
        this.parseData(data);
      };

      return this.socket;
    },
    parseData(data) {
      // console.log(data)
      this.renderGraph(data);
    },
    renderGraph(data) {
      let p = JSON.parse(data);
      //First graph
      console.log(p);

      let d1 = {
        chartData: {
          labels: [
            "JAN",
            "FEB",
            "MAR",
            "APR",
            "MAY",
            "JUN",
            "JUL",
            "AUG",
            "SEP",
            "OCT",
            "NOV",
            "DEC",
          ],
          datasets: [
            {
              label: "Accidents",
              fill: true,
              backgroundColor: "rgba(204, 218, 70, 1)",
              borderColor: "rgba(204, 218, 70, 1)",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: p.accByMonth.map((a) => a.Total),
            },
          ],
        },
        extraOptions: chartConfigs.barChartOptionsGradient,
        gradientColors: [
          "rgba(204, 218, 70, 0.8)",
          "rgba(246, 206, 71, 0.2)",
          "rgba(246, 206, 71, 0.0)",
        ],
        gradientStops: [1, 0],
      };

      let d2 = {
        chartData: {
          labels: [
            "JAN",
            "FEB",
            "MAR",
            "APR",
            "MAY",
            "JUN",
            "JUL",
            "AUG",
            "SEP",
            "OCT",
            "NOV",
            "DEC",
          ],
          datasets: [
            {
              label: "Class 1 (Fatality)",
              fill: true,
              borderColor: "#ffd369",
              backgroundColor: "#ffd369",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: p.accByClass.map((a) => a.Fatal),
            },
            {
              label: "Class 1 (Major)",
              fill: true,
              borderColor: "#e26241",
              backgroundColor: "#e26241",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: p.accByClass.map((a) => a.Major),
            },
            {
              label: "Class 2 (Minor)",
              fill: true,
              borderColor: "#940a37",
              backgroundColor: "#940a37",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: p.accByClass.map((a) => a.Minor),
            },
            {
              label: "Class 3 (First Aid Near Miss)",
              fill: true,
              borderColor: "#5b0909",
              backgroundColor: "#5b0909",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: p.accByClass.map((a) => a.FirstAid),
            },
          ],
        },
      };

      let d3 = {
        chartData: {
          labels: [
            "JAN",
            "FEB",
            "MAR",
            "APR",
            "MAY",
            "JUN",
            "JUL",
            "AUG",
            "SEP",
            "OCT",
            "NOV",
            "DEC",
          ],
          datasets: [
            {
              label: "MC",
              fill: true,
              backgroundColor: "#bbe1fa",
              borderColor: "#bbe1fa",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: p.McByMonth.map((a) => a.Mc),
            },
            {
              label: "LTI",
              fill: true,
              backgroundColor: "#0f4c75",
              borderColor: "#0f4c75",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: p.McByMonth.map((a) => a.Lti),
            },
          ],
        },
        extraOptions: chartConfigs.barChartOptionsGradient,
        // gradientColors: [
        //   "rgba(246, 206, 71, 0.8)",
        //   "rgba(246, 206, 71, 0.2)",
        //   "rgba(246, 206, 71, 0.0)"
        // ],
        gradientStops: [1, 0],
      };
      // Bar Chart
      let d4 = {
        chartData: {
          labels: [
            "JAN",
            "FEB",
            "MAR",
            "APR",
            "MAY",
            "JUN",
            "JUL",
            "AUG",
            "SEP",
            "OCT",
            "NOV",
            "DEC",
          ],
          datasets: [
            {
              label: "Property",
              fill: true,
              backgroundColor: "#3282b8",
              borderColor: "#3282b8",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              data: p.PropByMonth.map((a) => a.TotalCount),
            },
          ],
        },
      };

      let d5 = {
        chartData: {
          labels: [
            "Unsafe Act",
            "Unsage Condition",
            "Out of Control",
            "Others",
          ],
          datasets: [
            {
              pointRadius: 0,
              pointHoverRadius: 0,
              backgroundColor: ["#10316b", "#000000", "#e25822", "#ececeb"],
              borderWidth: 0,
              data: [
                p.donutchart.UnsafeNon,
                p.donutchart.UnsafeCon,
                p.donutchart.UnsafeControl,
                p.donutchart.UnsafeOther,
              ],
            },
          ],
        },
        extraOptions: chartConfigs.pieChartOptions,
      };

      let d6 = {
        chartData: {
          labels: [
            "Traffic",
            "Collection Activity",
            "Cleaning Activity",
            "Others",
          ],
          datasets: [
            {
              pointRadius: 0,
              pointHoverRadius: 0,
              backgroundColor: ["#004445", "#2c7873", "#6fb98f", "#ffd800"],
              borderWidth: 0,
              data: [
                p.donutchart.Traffic,
                p.donutchart.CollectActivity,
                p.donutchart.CleanActivity,
                p.donutchart.Other,
              ],
            },
          ],
        },
        extraOptions: chartConfigs.pieChartOptions,
      };
      console.log(p.donutchart.UnsafeAct);
      this.barChart1 = d1;
      this.barChart2 = d2;
      this.barChart3 = d3;
      this.barChart4 = d4;
      this.pieChart1 = d6;
      this.pieChart2 = d5;
      this.tableData = [];
      this.tableData.push(...p.incidentloc);
      console.log(this.tableData);
    },
    tableRowClassName({ rowIndex }) {
      if (rowIndex === 0) {
        return "table-red";
      } else if (rowIndex === 2) {
        return "table-red";
      }
      return "";
    },
    tableRowClassReminder({ rowIndex }) {
      if (rowIndex === 2) {
        return "table-red";
      } else if (rowIndex === 3) {
        return "table-red";
      }
      return "";
    },
  },
};
</script>
<style lang="scss" scoped>
.footer-font {
  font-size: 110%;
}
.tab {
  margin-left: 1%;
  margin-right: 1%;
}
.test {
  width: 800px;
}
.dialog {
  margin-left: 30%;
}
</style>
